import '../chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.TopInfluencersTweetsChartView extends Monitoring.Views.Charts.ChartView

  className: 'processing item w2 h2 posts-chart'
  defaultSize: 'w2'
  template: JST['backbone/templates/monitoring/charts/posts_chart']
  url: "/monitoring/api/charts/top_influencers_tweets"

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facets = @options.facets
    @_settings = @options.settings
    @container = @options.container
    @title = I18n.t('monitoring.dashboard.charts.top_influencers_tweets.title')
    @postWidgets = []

  render: ->
    @$el.html(@template({title: @title}))
    @

  afterAppend: ->
    @ajaxCall(@url, @searchQuery.toJSON(), (response) =>
      @$el.removeClass('processing')
      @postWidgets = response.map((serializedPost) => @addPostWidgetWith(serializedPost))
      @trigger('masonry')
    )

  addPostWidgetWith: (serializedPost) ->
    widget = new VueInBackbone.VueComponent('twitter-post-widget', serializedPost)
    @addPostWidget(widget)
    widget.render()

  addPostWidget: (postWidget) ->
    @vueContainer().append(postWidget.el)

  vueContainer: ->
    @$el.find('#posts_chart')

  destroy: ->
    @postWidgets.forEach((postWidget) => postWidget.remove())
    super()
